export const ROLE =
{
    ADMIN: "ROLE_ADMIN",
    ANALISTA: "ROLE_ANALISTA",
    GESTOR: "ROLE_GESTOR",
    TESTER: "ROLE_TESTER",
    USER: "ROLE_USER"
} 